import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
//import UploadSuperstarAuction from '../UploadSuperstarAuction/UploadSuperstarAuction';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";
import useFileHandleS3 from "../../../../../../../CustomHooks/useFileHandleS3";
import useProductImageHandleS3 from "../../../../../../../CustomHooks/useProductImageHandleS3";
import MediaUploadProgressBar from "../../../../../../../Screen/MediaUploadProgressBar";

const EditProductAuction = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  let { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);

  const history = useHistory();

  useEffect(() => {
    axios.get(`/api/star/edit/auction/${id}`).then((res) => {
      if (res.status === 200) {
        setInputFieldList(res.data.product);
        setFilePath(res.data.product.banner);
        setImagePath(res.data.product.product_image);
      }
    });
  }, []);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [inputFieldList, setInputFieldList] = useState({
    title: "",
    keyword: "",
    details: "",
    base_price: "",
    bid_from: "",
    bid_to: "",
    result_date: "",
    product_delivery_date: "",
    banner: "",
    product_image: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputFieldList((prev) => {
      return { ...prev, [name]: value };
    });
  };


  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);

    // File Handle Banner
    const [filePath, setFilePath] = useState("");
    const [file, setFile] = useState("");
    const [delKey, setDelKey] = useState(null);
    const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'auction/images', delKey);
  
    // File Handle Product Image
    const [imagePath, setImagePath] = useState("");
    const [productImage, setProductImage] = useState('');
    const [productImageDelKey, setProductImageDelKey] = useState(null);
    const [productImageUrl,productImageKey,progressBar] = useProductImageHandleS3(productImage, 'auction/images', productImageDelKey);


    const bannerHandler = (file) => {
      setDelKey(fileKey);
      setFile(file[0]);
    };
  
    const productImageHandler = (file) => {
      setProductImageDelKey(productImageKey);
      setProductImage(file[0]);
    };
  
  
    const deleteFile = ()=>
    {
      setFile(null);
      setDelKey(fileKey);
      fileInputRef.current.value = '';
  
    }

    const deleteProductImage = ()=>
    {
      setProductImage(null);
      setProductImageDelKey(productImageKey);
      imageInputRef.current.value = '';
  
    }

  const dataSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("title", inputFieldList.title);
    fData.append("keyword", inputFieldList.keyword);
    fData.append("details", convertedContent);
    fData.append("base_price", inputFieldList.base_price);
    fData.append("bid_from", inputFieldList.bid_from);
    fData.append("bid_to", inputFieldList.bid_to);
    fData.append("result_date", inputFieldList.result_date);
    fData.append("product_delivery_date", inputFieldList.product_delivery_date);
    fData.append("banner", fileKey?fileKey:filePath);
    fData.append("status", 0);
    fData.append("product_image", productImageKey?productImageKey:imagePath);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/update/auction/${id}`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 402) {
          setErrorList(res.data.errors);
        } else {
          if(file){
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }
          if(productImage){
            setProductImage('');
            setProductImageDelKey(imagePath.split("com/").pop())
          }

          history.push(
            `/superstar/auction/confirm-or-edit-super-auction/${id}`
          );
        }
      });
    });
  };

  return (
    <div className="AS">
      {/* <SouvenirNav /> */}
      <div className="text-light d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Edit Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 mt-3 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form onSubmit={dataSubmit}>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="title"
                        value={inputFieldList.title}
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Keyword</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="keyword"
                        value={inputFieldList.keyword}
                      />
                      <span className="text-danger">{errorList.keyword}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className=" col-md-3 label-text">
                      <p>Description</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={inputFieldList.details}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">{errorList.details}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Base Price</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="base_price"
                        onChange={handleInput}
                        value={inputFieldList.base_price}
                      />
                      <span className="text-danger">
                        {errorList.base_price}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4 text-warning">
                    <div className=" col-md-3 label-text">
                      <p>Bidding Deadline</p>
                    </div>
                    <div className="col-sm-4 ">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="bid_from"
                        value={moment(inputFieldList.bid_from).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">{errorList?.bid_from}</span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="bid_to"
                        value={moment(inputFieldList.bid_to).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">{errorList?.bid_to}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className=" col-md-3 label-text">
                      <p>Result Published</p>
                    </div>

                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="result_date"
                        value={moment(inputFieldList.result_date).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">
                        {errorList?.result_date}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className=" col-md-3 label-text">
                      <p>Product Delivery</p>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="product_delivery_date"
                        value={moment(
                          inputFieldList.product_delivery_date
                        ).format("YYYY-MM-DD")}
                      />
                      <span className="text-danger">
                        {errorList?.product_delivery_date}
                      </span>
                    </div>
                  </div>

                  {/* <div className="col-md-4"> */}
                  <div className="row my-4">
                    <div className=" col-md-3 label-text">
                      <p>Upload Banner</p>
                    </div>
                    <div className="col-md-5 text-success">
                    {fileUrl && file? (
                        <div className="position-relative">
                    
                          <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                      <input
                        type="file"
                        name="banner"
                        id="file"
                        className="inputfile"
                        onChange={(e) => bannerHandler(e.target.files)}
                        ref={fileInputRef}
                      />
                    {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}

                      <label for="file">
                        <i className="fas fa-cloud-upload-alt"></i> Upload
                      </label>
                    </div>
                    <span className="text-danger">{errorList.banner}</span>
                  </div>

                  <div className="row my-4">
                    <div className=" col-md-3 label-text">
                      <p>Product Image</p>
                    </div>
                    <div className="col-md-5 text-success">
                    {productImageUrl && productImage? (
                        <div className="position-relative">
                    
                          <img
                          src={productImageUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteProductImage}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + imagePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                      <input
                        type="file"
                        name="product_image"
                        id="product"
                        className="inputfile"
                        onChange={(e) => productImageHandler(e.target.files)}
                        ref={imageInputRef}
                      />
                      {productImage && !productImageUrl && <MediaUploadProgressBar progress={progressBar} />}
                      <label for="product">
                        <i className="fas fa-cloud-upload-alt"></i> Upload
                      </label>
                      <span className="text-danger">
                        {errorList.product_image}
                      </span>
                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center ">
                      <Link to={`/superstar/auction-product-list/pending`}>
                        <button className="btn btnGoBack fw-bold me-2">
                          Go Back
                        </button>
                      </Link>
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProductAuction;
